module.exports = __webpack_public_path__ + "static/NT-f57b10f38b2b70b982ee447c56e65fc0.svg";